import { useCurrencyContext, type CurrencyFormatOptions } from '../contexts/CurrencyContext';
import { CURRENCY_META, type SupportedCurrency } from '../store/slices/currencySlice';

interface CurrencyDisplay {
  /** The active 3-letter code, e.g. "EUR" */
  currency: SupportedCurrency;
  /** The symbol prefix, e.g. "€" */
  symbol: string;
  /** The exchange rate from USD to the active currency */
  rate: number;
  /**
   * Converts a USD amount into the user's preferred currency string.
   * e.g. formatValue(1234.5) → "€1,134.54" when EUR is selected.
   */
  formatValue: (usdAmount: number, options?: CurrencyFormatOptions) => string;
  /**
   * Returns just the numeric part without symbol, useful for aria-labels.
   */
  formatNumber: (usdAmount: number, options?: CurrencyFormatOptions) => string;
}

export function useCurrencyDisplay(): CurrencyDisplay {
  const { displayCurrency, getRate, formatValue, formatNumber } = useCurrencyContext();
  const rate = getRate(displayCurrency);
  const currency = displayCurrency;
  const { symbol } = CURRENCY_META[currency];

  return {
    currency,
    symbol,
    rate,
    formatValue,
    formatNumber,
  };
}
